import trim from "lodash/trim";
import generateId from "logic/generateId";
const CreateSearchFilterFromCurrentQuery = (editor, { searchFilters: { addFilter } }) => {
  const queryString = editor.getValue();
  if (trim(queryString) === "") {
    return;
  }
  const frontendId = generateId();
  addFilter(
    {
      frontendId,
      queryString,
      disabled: false,
      negation: false,
      type: "inlineQueryString"
    },
    false
  );
  editor.setValue("");
};
export default CreateSearchFilterFromCurrentQuery;
